import useContext from "../../../context";
import ClosingCostDetails from "./ClosingCostDetails";

const dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  trailingZeroDisplay: 'stripIfInteger',
});

export default function Card({ option, openEmailModal, disabled = false }) {
  const [context, updateContext] = useContext();

  const isCreditCheck = option === 'creditCheck';

  const data = context.response[option];

  const isRefinance = context.contractType === 'refinance';

  return (
    <div className="quoteform__option">
      <div className="optioncard optioncard--active">
        <div className="optioncard__header">
          <span>{ isCreditCheck ? 'Credit Check Option' : 'No Credit Check Option' }</span>
        </div>
        <div className="optioncard__body">
          <div className="optioncard__item">
            <span className="optioncard__item-title optioncard__item-title--isBig">Your Estimated Monthly Payment:</span>
            <span className="optioncard__item-value optioncard__item-value--isBig">{dollars.format(data.monthly_payment)}/mo.</span>
          </div>
          <div className="optioncard__item">
            <span className="optioncard__item-title">Interest Rate:</span>
            <span className="optioncard__item-value">{data.interest_rate}%</span>
          </div>
          <div className="optioncard__item">
            <span className="optioncard__item-title">Loan Term:</span>
            <span className="optioncard__item-value">{data.loan_term} years</span>
          </div>
          {!isRefinance &&
            <div className="optioncard__item">
              <span className="optioncard__item-title">Down Payment:</span>
              <span className="optioncard__item-value">{dollars.format(data.down_payment)} <span className="small light">({data.down_payment_percent}%)</span></span>
            </div>
          }
          <div className="optioncard__item">
            <span className="optioncard__item-title">Total Loan Amount:</span>
            <span className="optioncard__item-value">{dollars.format(data.total_loan_amount)}</span>
          </div>
          <div className="optioncard__item">
            <span className="optioncard__item-title"><strong>{isRefinance ? 'Estimated Proceeds after Closing' : 'Estimated Cash to Close' }{ (!isRefinance && data.estimated_cash_to_close < 0) ? <span className="negative">*</span> : '' }:</strong></span>
            <span className="optioncard__item-value"><strong>{dollars.format(isRefinance ? data.estimated_proceeds : data.estimated_cash_to_close)}</strong></span>
          </div>
          <ClosingCostDetails option={option} />
          <div className="optioncard__actions" onClick={() => !disabled && updateContext((ctx) => {
            ctx.loanOption = option;

            return ctx;
          })}>
            <button className="btn-primary btn-primary--isOverlapping" disabled={disabled}>Apply Now</button>
          </div>
        </div>
      </div>
      <button className="optioncard__email-link" onClick={openEmailModal} disabled={disabled}>
        <i className="fas fa-paper-plane"></i>
        <span>Email this quote</span>
      </button>
    </div>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanCards/components/Card.js